import React from 'react';
import { Typography } from '@material-ui/core';

function Err404() {
  return <Typography variant={'h2'}>Not found</Typography>;
}

export default Err404;
